import React, { useContext } from 'react'
import { AppContext } from '../App'

export default function AppBody() {
   const { renderSwitch, appStep } = useContext(AppContext)
   return (
      <div className="row app-body">
            { renderSwitch(appStep) }
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/AppBody.js